// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
export type LogLineFieldsFragment = {
  __typename?: "LogLine";
  id: string;
  occurredAt: string;
  logClassification?: string | null;
  logText?: string | null;
  backendPid?: number | null;
  databaseId?: string | null;
  postgresRoleId?: string | null;
  postgresRoleName?: string | null;
};

export const LogLineFieldsFragmentDoc = gql`
  fragment LogLineFields on LogLine {
    id
    occurredAt
    logClassification
    logText(maxLength: $logTextMaxLength)
    backendPid
    databaseId
    postgresRoleId
    postgresRoleName
  }
`;
